import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from '@mui/material';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

export default function BrdDocumentLink({ className }) {
    const { userInfo } = useContext(PrivateRoutesContext);

    const openBrd = () => {
        window.open(userInfo?.companyDetails?.brdLink, '_blank').focus();
    }

    return (
        <>
            {userInfo?.companyDetails?.brdLink ?
                <Button
                    className={className}
                    variant="outlined"
                    color="primary"
                    onClick={openBrd}
                    startIcon={<ArticleOutlinedIcon />}
                >
                    View BRD
                </Button>
            : null}
        </>
    )
}